export default "__VITE_ASSET__oeuQGnfp__"